import { motion } from "framer-motion";
import Reveal from "./Reveal";

const CHAPTERS = [
  { n: "01", t: "Produção Artesanal", d: "Cada criação é feita à mão, em pequenos lotes, respeitando o tempo e a técnica que o sabor merece." },
  { n: "02", t: "Feito com Carinho", d: "Colocamos afeto em cada detalhe, porque acreditamos que doce bom se sente antes mesmo de provar." },
  { n: "03", t: "Qualidade e Detalhes", d: "Ingredientes selecionados e acabamento impecável para transformar momentos em memórias inesquecíveis." },
];

const About = () => {
  return (
    <section id="sobre" className="bg-choco text-cream py-24 lg:py-32 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-5 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div>
          <Reveal>
            <p className="text-xs uppercase tracking-luxe text-gold mb-5">Sobre a Deco Sweet</p>
            <h2 className="font-serif text-4xl sm:text-5xl leading-tight mb-6">
              Nascemos do amor pela confeitaria e do desejo de <span className="font-script text-gold text-5xl sm:text-6xl">encantar</span>
            </h2>
            <p className="text-cream/70 leading-relaxed max-w-lg mb-10">
              A Deco Sweet transforma momentos especiais em memórias doces. Aqui, cada criação é feita com dedicação, carinho e ingredientes selecionados para encantar você e quem você ama.
            </p>
          </Reveal>

          <div className="space-y-8">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.12}>
                <div className="flex gap-6 border-t border-cream/15 pt-6">
                  <span className="font-serif text-3xl text-gold leading-none">{c.n}</span>
                  <div>
                    <h3 className="font-serif text-2xl mb-1">{c.t}</h3>
                    <p className="text-sm text-cream/65 leading-relaxed max-w-md">{c.d}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.15}>
          <motion.div whileHover={{ scale: 1.02 }} transition={{ duration: 0.6 }}
            className="relative rounded-[2rem] overflow-hidden h-[440px] lg:h-[640px] shadow-2xl">
            <img src="https://images.unsplash.com/photo-1549590143-d5855148a9d5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" alt="Confeiteira artesanal Deco Sweet" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-choco/10" />
          </motion.div>
        </Reveal>
      </div>
    </section>
  );
};

export default About;
